export const USER_TYPE = 'user';
export const ROLE_TYPE = 'role';
export const FOR_ALL_TYPE = 'all';
export const SUBSCRIPTION_TYPE = 'subscription';
export const NEW_USER_TYPE = 'new_user';

const createRule = (type, value) => ({ type, value });

export const getRulesFromDiscountCodeData = (
  allCheckbox,
  userCheckbox,
  roleCheckbox,
  subscriptionCheckbox,
  users,
  roles,
  subscriptions,
  newUserCheckbox
) => {
  const rules = [];
  if (allCheckbox) {
    rules.push(createRule(FOR_ALL_TYPE, null));

    return rules;
  }

  if (newUserCheckbox) {
    rules.push(createRule(NEW_USER_TYPE, null));
  }

  if (userCheckbox) {
    users.forEach((user) => rules.push(createRule(USER_TYPE, user)));
  }

  if (roleCheckbox) {
    roles.forEach((role) => rules.push(createRule(ROLE_TYPE, role)));
  }

  if (subscriptionCheckbox) {
    subscriptions.forEach((subscription) => rules.push(createRule(SUBSCRIPTION_TYPE, subscription)));
  }

  return rules;
};
